import * as React from 'react';
import {connect} from 'react-redux';

import type {SalesAutomationItemType} from '../../../../sales-automation/types';

import {setActiveItem} from '../../ui-actions';

import {singleCardWidth, additionalCardWidth} from './email-marketing/constants';
import {SalesAutomationCardEmailWrapper} from './sales-automation-card-email-wrapper';

import styles from './sales-automation-card-email.module.css';

// @ts-expect-error
const mapDispatchToProps = function (dispatch, ownProps: OwnProps): DispatchProps {
    return {
        onItemEdit: () => {
            dispatch(
                setActiveItem({
                    parentId: ownProps.stageId,
                    type: ownProps.type,
                    entityId: ownProps.entityId,
                })
            );
        },
    };
};

type OwnProps = {
    stageId: string;

    entityId: string;

    type: SalesAutomationItemType;
    isDisabled: boolean;
    isHidden: boolean;
    size: 'small' | 'medium' | 'large';
    isFirstStage: boolean;
    alignTop?: boolean;
    numberOfStagesSpanned: number;
    children?: React.ReactNode;
};

type DispatchProps = {
    onItemEdit: () => any;
};

type Props = OwnProps & DispatchProps;

export class SalesAutomationStretchCardComponent extends React.PureComponent<Props> {
    render() {
        const additionalCardLengthsToApply = this.props.numberOfStagesSpanned - 1;
        let totalWidth = singleCardWidth + additionalCardLengthsToApply * additionalCardWidth;

        // If it's the first stage, we add 4px. smh wtf
        if (this.props.isFirstStage) {
            totalWidth = totalWidth + 4;
        }

        return (
            <SalesAutomationCardEmailWrapper isHidden={this.props.isHidden} size={this.props.size}>
                <button
                    type='button'
                    style={{
                        width: totalWidth,
                        alignItems: this.props.alignTop ? 'unset' : undefined,
                    }}
                    onClick={this.props.onItemEdit}
                    className={
                        this.props.isDisabled
                            ? styles['absolute-container--disabled']
                            : styles['absolute-container']
                    }
                >
                    {this.props.children}
                </button>
            </SalesAutomationCardEmailWrapper>
        );
    }
}

// @ts-expect-error
const connector = connect<Props, OwnProps, _, _, _, _>(null, mapDispatchToProps);
export const SalesAutomationStretchCard = connector(SalesAutomationStretchCardComponent);
